import dayjs from "dayjs";
import "dayjs/locale/ar";

/** `price_per_year` of a subscription plan (PROLINE-4136). */
const yearlyPrice = (plan) => Number(plan?.price_per_year) || 0;

/**
 * Difference to pay on an upgrade: new yearly price − current yearly price, not prorated
 * (PROLINE-4150). The backend doesn't return it.
 */
export const getPlanChangeDifference = ({ currentPlan, newPlan }) =>
  yearlyPrice(newPlan) - yearlyPrice(currentPlan);

/** "15 Jan 2026" in both languages, with the month in the current language. */
export const formatSubscriptionDate = (date, lang) =>
  date ? dayjs(date).locale(lang === "ar" ? "ar" : "en").format("DD MMM YYYY") : "—";
